import { ApiEndpoints } from '@/types/routes';
import { IHttpClient } from '@/api/HttpClient';
import {
  ICalculatorsApi,
  IGetCalculatorCexRatingsResponse,
  IGetCalculatorCustodyRatings,
  IGetCalculatorEtfRatings,
  IGetCalculatorPdRatings,
  IGetLossCalculationsRequest,
  IGetLossCalculationsResponse,
} from '@/api/calculators/calculators.types';

export class CalculatorsApi implements ICalculatorsApi {
  private getBaseUrl(): string {
    return ApiEndpoints.CALCULATORS;
  }

  constructor(private readonly httpClient: IHttpClient) {}

  getLossCalculations({
    contagionLevel,
    entities,
    lossThresholdPct,
    alphaPct,
  }: IGetLossCalculationsRequest) {
    const params = {
      contagionLevel,
      entities,
      lossThresholdPct,
      alphaPct,
    };

    return this.httpClient.post<Partial<IGetLossCalculationsRequest>, IGetLossCalculationsResponse>(
      this.getBaseUrl(),
      params,
    );
  }

  getExchanges() {
    return this.httpClient.get<IGetCalculatorCexRatingsResponse>(`${this.getBaseUrl()}exchanges/`);
  }

  getCustodiansHistoricalRatings() {
    return this.httpClient.get<IGetCalculatorCustodyRatings[]>(
      `${this.getBaseUrl()}ccr/historical/`,
    );
  }

  getEtfHistoricalRatings() {
    return this.httpClient.get<IGetCalculatorEtfRatings[]>(`${this.getBaseUrl()}etfs/historical/`);
  }

  getLiquidityProviderHistoricalRatings() {
    return this.httpClient.get<IGetCalculatorPdRatings[]>(
      `${this.getBaseUrl()}liquidity_providers/historical/`,
    );
  }

  getStablecoinHistoricalRatings() {
    return this.httpClient.get<IGetCalculatorPdRatings[]>(
      `${this.getBaseUrl()}stable_coins/historical/`,
    );
  }
}
